import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { DatePipe } from '@angular/common';
import { ColorPickerModule } from 'ngx-color-picker';

import { AppRoutingModule } from './app-routing.module';
import { MainPipe } from './shared/mainPipe.module';

import { APP_INITIALIZER } from '@angular/core';
import { AppConfig } from './Services/app.config';

import { AppComponent } from './app.component';
import { AdminComponent } from './admin/admin.component';
import { ApplicationComponent } from './application-dashboard/application.component';
import { MonthDashboardComponent } from './month-dashboard/month-dashboard.component';
import { NotesDetailComponent } from './notes-detail/notes-detail.component';
import { DeployCalendarComponent } from './deploy-calendar/deploy-calendar.component';
import { NoteEntryComponent } from './note-entry/note-entry.component';
import { EmailSignatureComponent } from './email/email-signature.component'
import { EmailBodyComponent } from './email/email-body.component'
import { PublishEmailComponent } from './email/publish-email.component';
import { AppEntryComponent } from './app-entry/app-entry.component';
import { BreadcrumbComponent } from './shared/breadcrumb.component';
import { AlertComponent } from './shared/alert.component';
import { SigninRedirectCallbackComponent } from './signin-redirect-callback/signin-redirect-callback.component';
import { SignoutRedirectCallbackComponent } from './signout-redirect-callback/signout-redirect-callback.component';


export function initializeApp(appConfig: AppConfig) {
  return () => appConfig.load();
}
@NgModule({
  declarations: [
    AppComponent,
    AdminComponent,
    ApplicationComponent,
    MonthDashboardComponent,
    NotesDetailComponent,
    DeployCalendarComponent,
    NoteEntryComponent,
    EmailSignatureComponent,
    EmailBodyComponent,
    PublishEmailComponent,
    AppEntryComponent,
    BreadcrumbComponent,
    AlertComponent,
    SigninRedirectCallbackComponent,
    SignoutRedirectCallbackComponent
  ],
  imports: [
    BrowserModule,
    NgbModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    MainPipe,
    ColorPickerModule
  ],
  providers: [DatePipe, AppConfig,
    { provide: APP_INITIALIZER,
      useFactory: initializeApp,
      deps: [AppConfig], multi: true }],
  bootstrap: [AppComponent]
})
export class AppModule { }
